<template>
    <div class="illegalInfo">
        <h3></h3>
        <van-nav-bar
            title="监播详情"
            left-text="返回"
            left-arrow
            @click-left="$router.push('/home')"
        />
    </div>
</template>

<script>
export default {
    name: 'MonitorDetailView'
};
</script>

<style scoped>

</style>
